import './config.dev';
import './config.production';

export const Config = process.env.NODE_ENV === 'production' ? global.prodConfig : global.devConfig;
